export default class TrackGraphic {
	DescriptionFile = ''
}